import { render } from "./JudgeCard.vue?vue&type=template&id=5428e386&scoped=true"
import script from "./JudgeCard.vue?vue&type=script&lang=js"
export * from "./JudgeCard.vue?vue&type=script&lang=js"

import "./JudgeCard.vue?vue&type=style&index=0&id=5428e386&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5428e386"]])

export default __exports__